var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.91 14.085a.486.486 0 0 0 .722 0l3.976-4.416a1 1 0 0 0 0-1.338L7.675 3.963a.543.543 0 1 0-.807.728l3.59 3.974a.5.5 0 0 1 0 .67L6.91 13.262a.614.614 0 0 0 0 .823",
  clipRule: "evenodd"
})));
export default SvgArrow;